import { Navigate } from "react-router-dom";

export default function RoleRedirect() {
  const storedUser = localStorage.getItem("user");

  let user = null;
  try {
    user = storedUser ? JSON.parse(storedUser) : null;
  } catch (error) {
    console.error("Error parsing user:", error);
  }

  if (!user) {
    console.log("No user found, redirecting to login");
    return <Navigate to="/login" replace />;
  }

  if (user?.mustChangePassword) {
    return <Navigate to="/change-password" replace />;
  }

  const role = String(user.role).toUpperCase();

  switch (role) {
    case "ADMIN":
      return <Navigate to="/home/admin" replace />;
    case "DIRECTOR":
      return <Navigate to="/home/director" replace />;
    case "SUPERVISOR":
      return <Navigate to="/home/supervisor" replace />;
    case "OPERARIO":
      return <Navigate to="/home/operator" replace />;
    default:
      return <Navigate to="/login" replace />;
  }
}
